// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"da335bc3","193":"d9c9f4df","514":"f5238fa8","958":"e572ee54"}[chunkId] + ".chunk.js";
};